import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
// import IconDownloadOutline from "@iconify/icons-eva/download-outline";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import RefreshIcon from "@mui/icons-material/RefreshOutlined";
import SendIcon from "@mui/icons-material/SendAndArchive";
import trash2Fill from "@iconify/icons-eva/trash-2-fill";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
// material
import { styled } from "@mui/material/styles";
import { Box, ButtonGroup, Button, Toolbar, Tooltip, IconButton, Stack, Typography, OutlinedInput, InputAdornment } from "@mui/material";
import { useRef, useState } from "react";
import TimeUtil from "src/utils/TimeUtil";
import { PAYMENT_STATUS, STORE_ORDER_STATUS } from "src/config/constants";
import XLSX from "xlsx";

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 340,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 340, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

PaymentListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

const types = [
  { name: "all", label: "全部" },
  { name: "pending", label: "待支付", value: PAYMENT_STATUS.PENDING, count: 0 },
  { name: "payed", label: "已支付", value: PAYMENT_STATUS.PAYED, count: 0 },
  { name: "timeout", label: "已超时", value: PAYMENT_STATUS.TIMEOUT, count: 0 },
  // { name: "refunding", label: "退款中", value: PAYMENT_STATUS.REFUNDING, count: 0 },
  { name: "refunded", label: "已退款", value: PAYMENT_STATUS.REFUNDED, count: 0 },
  { name: "canceled", label: "已取消", value: PAYMENT_STATUS.CANCELED, count: 0 },
  // { name: "deleted", label: "已删除", value: STORE_ORDER_STATUS.DELETED, count: 0 },
];

// , "自定义"
const times = ["全部", "今天", "昨天", "近7天", "近30天", "本月", "本年"];

export default function PaymentListToolbar({ numSelected, onDateChange, onStatusChange, onExport, onSearch, onRefresh, countMap = {}, total = 0, onBulkSend, children }) {
  const [type, setType] = useState("all");
  const [time, setTime] = useState("全部");
  const [search, setSearch] = useState("");

  const uploadRef = useRef();

  function handleTypeClick(t) {
    setType(t.name);

    onStatusChange(t.name === "all" ? -1 : t.value);
  }

  function handleTimeClick(t) {
    setTime(t);

    onDateChange(t === "全部" ? null : TimeUtil.getTimeRange(t));
  }

  function handleUpload(e) {
    if (!e.target.files[0]) return;
    let reader = new FileReader();
    reader.onload = (event) => {
      uploadRef.current.value = null;
      try {
        // 判断文件类型是否正确
        // if (".xls" != suffix && ".xlsx" != suffix) {
        //     message.error("选择Excel格式的文件导入!");
        //     return false;
        // }
        let { result } = event.target;
        // 读取文件
        let workbook = XLSX.read(result, { type: "binary" });
        let data = [];
        // 循环文件中的每个表
        for (let sheet in workbook.Sheets) {
          // console.log('sheet: ', sheet);
          // if (workbook.Sheets.hasOwnProperty(sheet)) {
          //   // 将获取到表中的数据转化为json格式
          // }

          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { defval: '' });
          // console.log(sheetData)
          // setInitialData(sheetData);
          // setShowImportDialog(true);
          onBulkSend(sheetData);

        }
        // console.log("data:", data);
      } catch (e) {
        console.log(e);
        alert("文件类型不正确！");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  return (
    <Stack>
      <Box marginX={2} mt={2}>
        <ButtonGroup variant="outlined" aria-label="outlined button group">
          {types.map((t) => {
            const { name, label, value } = t;
            let count = countMap[value] || 0;
            if (name === 'all') {
              count = total;
            }

            return (
              <Button key={name} variant={type === name ? "contained" : "outlined"} onClick={() => handleTypeClick(t)}>
                {label} {count != null ? `(${count})` : ""}
              </Button>
            );
          })}
        </ButtonGroup>
      </Box>
      <Box marginX={2} marginY={1}>
        <ButtonGroup variant="outlined" aria-label="outlined button group">
          {times.map((t) => (
            <Button key={t} variant={time === t ? "contained" : "outlined"} onClick={() => handleTimeClick(t)}>
              {t}
            </Button>
          ))}
        </ButtonGroup>
      </Box>
      <Box marginX={2} marginY={1} display="flex" alignItems="center">
        {numSelected > 0 ? (
          <Typography component="div" variant="subtitle1">
            选中{numSelected}条
          </Typography>
        ) : (
          <SearchStyle
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="根据用户ID、订单编号搜索..."
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: "text.disabled" }} />
              </InputAdornment>
            }
          />
        )}

        {children}

        <ButtonGroup variant="outlined" aria-label="outlined button group">
          <Button startIcon={<SearchIcon />} onClick={() => onSearch(search)}>
            搜索
          </Button>
          <Button startIcon={<DownloadIcon />} onClick={onExport}>
            导出
          </Button>
          <Button startIcon={<RefreshIcon />} onClick={onRefresh}>
            刷新
          </Button>
        </ButtonGroup>
      </Box>
    </Stack>
  );
}
